export default __webpack_public_path__ + "static/media/address-home.6739782d.svg";